import { Box,Button } from "@material-ui/core";
import Stack from '@mui/material/Stack';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import {getposts} from '../../actions/posts'
import { useDispatch } from "react-redux";
import Posts from "../Posts/Posts";
import Form from "../Form/Form";
import React, { useEffect,useState } from "react";
import useStyles from './style'
import { Userlist } from '../UsersList/Userlist'
import {getUser} from '../../actions/Userlist'
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Modal } from "../Modal/Modal";

export const Home = () => {

    const disptach=useDispatch()
    const classes=useStyles()
    const [currentId,setCurrentId]=useState(null)
    const [createview,setCreateview]=useState(false)
    useEffect(()=>{
        disptach(getposts())
        disptach(getUser())
    },[currentId, disptach]);

  return (
      <Box>
      <h1>Form</h1>
     
        <Popup trigger={<Fab color="primary" aria-label="add" onClick={()=>{setCreateview(true)}}><AddIcon/></Fab>} 
        position="center">
        
        <Modal currentId={currentId} setCurrentId={setCurrentId} setCreateview={setCreateview}/>
        
     
      </Popup>
     
 

          <Stack direction="row" spacing={2} justifyContent="space-between" className={classes.container} >
            <Posts setCurrentId={setCurrentId}/>
            <Userlist/>
          </Stack>
      </Box>
  )
}
